import React from 'react'
import RegisterGoogleSimple from '../../../common/GoogleOriginalDesign/Foodslabo/Simple/RegisterGoogleSimple'

export default function GenieeLineRegister() {
    return (
        <RegisterGoogleSimple
            reasonPoint1Images={[
                {
                    src: '/pages/geniee/foodslabo/reason_point1_img1.png',
                    alt: 'GENIEEの限定求人詳細1枚目',
                },
                {
                    src: '/pages/geniee/foodslabo/reason_point1_img2.png',
                    alt: 'GENIEEの限定求人詳細2枚目',
                },
                {
                    src: '/pages/geniee/foodslabo/reason_point1_img3.png',
                    alt: 'GENIEEの限定求人詳細3枚目',
                },
            ]}
            signupPath='signup?channel=geniee_line'
        />
    )
}
